var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcSelectTags',{attrs:{"multiple":false},on:{"input":_vm.emitInput},model:{value:(_vm.integerValue),callback:function ($$v) {_vm.integerValue=$$v},expression:"integerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }